<template>
  <div v-if="getConfigStatus">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          <div>仓区优势级别定义 ：</div>
          <el-button
            style="margin-left: auto;"
            type="success"
            size="spaceSetting"
            @click="dialogVisible = true"
            >设置</el-button
          >
        </div>
        <div style="margin-bottom: 0;"></div>
        <div style="padding: 10px 25px;">
          <el-row>
            <el-col :span="2">
              库存仓区:
            </el-col>
            <el-col :span="22">
              <el-button v-for="area in form.stock" :key="area" size="small">{{
                area
              }}</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2">
              发货仓区:
            </el-col>
            <el-col :span="22">
              <el-button v-for="area in form.fahuo" :key="area" size="small">{{
                area
              }}</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="7">
              库存仓区是否单独生成越库拣货任务：
            </el-col>
            <el-col :span="17">
              <el-switch
                v-model="form.picking_alone"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          <div>库存分离设置 ：</div>
        </div>
        <div style="margin-bottom: 0;"></div>
        <div style="padding: 10px 25px;">
          <el-row>
            <el-col :span="3">
              是否开启库存分离：
            </el-col>
            <el-col :span="20">
              <el-switch
                v-model="form.stock_dabiao"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <el-checkbox
                v-for="method in form.method"
                :key="method"
                v-model="method.value"
                :disabled="form.stock_dabiao == 1 ? false : true"
                :checked="method.value == '1' ? true : false"
                :label="method.label"
                true-label="1"
                false-label="0"
                >{{ method.label }}</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              PC点货同一上架单内同一SKU有配货时未预配到订单的商品是否分离库存：
            </el-col>
            <el-col :span="14">
              <el-switch
                v-model="form.pc_tally_stock_dabiao"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              未预配到订单的商品上架至库存仓区时是否配货：
            </el-col>
            <el-col :span="17">
              <el-switch
                v-model="form.stock_upshelf_allot"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              前置仓商品未预配到订单是否库存分离：
            </el-col>
            <el-col :span="17">
              <el-switch
                v-model="form.pre_storage_goods_unallot"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <span style="color:#F00"
                >（开启后则前置仓商品只需判断是否有预配，且优先级最高，不参与其他库存分离判断）</span
              >
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              提前预测商品不参与库存分离：
            </el-col>
            <el-col :span="17">
              <el-switch
                v-model="form.forecast_plan_goods"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2">
              未动销设置：
            </el-col>
            <el-col :span="17">
              SKU超过
              <el-inputNumber
                v-model="form.moving_sales_days"
                size="mini"
                :min="0"
                :precision="0"
              ></el-inputNumber>
              天没有出库的进行库存分离
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button type="primary" @click="save()"> 保 存 </el-button>
      </el-col>
    </el-row>
    <el-dialog title="设置仓区" :visible.sync="dialogVisible" width="40%">
      <el-transfer v-model="fahuo" :data="allArea"></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetStockFahuo">取 消</el-button>
        <el-button type="primary" @click="handleStockFahuo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      loadding: false,
      getConfigStatus: true,
      form: {
        stock_dabiao: "0",
        pc_tally_stock_dabiao: "0",
        pc_tally_stock_dabiao_bh: "0",
        stock_upshelf_allot: "0",
        fahuo_stock_day: "",
        auto_allot_num: "",
        picking_alone: 0,
        method: [],
        fahuo: [],
        stock: [],
        moving_sales_days: 0, // 动销天数
        pre_storage_goods_unallot: 0, //  前置仓商品未预配到订单是否库存分离
        forecast_plan_goods: 0, // 提前预测商品是否库存分离
      },
      config: {},
      dialogVisible: false,
      stock: [],
      fahuo: [],
      allArea: [],
      pcTallyStockDaBiao: false,
    };
  },
  methods: {
    fetchData() {
      this.$http
        .get("/erp/AdminSetting/stockDetailSeparateSetting")
        .then(res => {
          if (res.data.code != 200) {
            this.$message.error("获取配置失败");
            this.getConfigStatus = false;
          }
          this.form.method = res.data.data.stock_dabiao_method;
          this.form.stock_dabiao = res.data.data.stock_dabiao;
          this.form.pc_tally_stock_dabiao = res.data.data.pc_tally_stock_dabiao;
          this.form.stock_upshelf_allot = res.data.data.stock_upshelf_allot;
          // this.form.fahuo_stock_day = res.data.data.fahuo_stock_day
          //this.form.auto_allot_num = res.data.data.auto_allot_num
          this.form.picking_alone = res.data.data.picking_alone;
          this.form.moving_sales_days = res.data.data.moving_sales_days || 0;
          this.form.pre_storage_goods_unallot =
            res.data.data.pre_storage_goods_unallot || 0;
          this.form.forecast_plan_goods =
            res.data.data.forecast_plan_goods || 0;
          this.allArea = [];
          let all_area = res.data.data.all_area;
          all_area.forEach((area, index) => {
            let item = [];
            item["key"] = area;
            item["label"] = area;
            this.allArea.push(item);
          });
          this.stock = this.form.stock = res.data.data.stock_area;
          this.fahuo = this.form.fahuo = res.data.data.fahuo_area;
        });
    },
    save() {
      this.$http
        .post("/erp/AdminSetting/stockDetailSeparateSetting", this.form)
        .then(res => {
          if (res.data.code != 200) {
            this.$message.error(res.data.msg);
            return false;
          }
          this.$message.success("保存成功");
          return true;
        });
    },
    resetStockFahuo() {
      this.stock = this.form.stock;
      this.fahuo = this.form.fahuo;
      this.dialogVisible = false;
    },
    handleStockFahuo() {
      let stock = [];
      let fahuo = [];
      let key = 0;
      //处理仓区设置
      this.allArea.forEach((item, index) => {
        if (this.fahuo.indexOf(item.label) > -1) {
          fahuo.push(item.label);
        } else {
          stock.push(item.label);
        }
      });
      this.stock = this.form.stock = stock;
      this.form.fahuo = this.fahuo = fahuo;
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
._block {
  display: block;
  margin-top: 20px;
  border: 1px solid #0e0e0e;
}
._label {
  margin-bottom: 10px;
}
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/StockDetailSeparateSetting.vue